import { useContext } from 'react'
import { TutorialContext, TutorialContextState } from './tutorialContext'

export const useTutorialContext = (): TutorialContextState => {
  const context = useContext(TutorialContext)
  if (context === undefined) {
    throw new Error('useTutorialContext must be used within a TutorialProvider')
  }
  return context
}
